import React from 'react';
import PropTypes from 'prop-types';
import Drawer from 'material-ui/Drawer';
import Icon from 'material-ui/Icon';
import ReactIframeResizer from 'react-iframe-resizer-super';

function resizedCallback_introduce() {
  document.getElementById("inneriframe_introduce").contentDocument.body.style.fontFamily = "Lato, 'Helvetica Neue', Helvetica, Arial, sans-serif";
  document.getElementById("inneriframe_introduce").contentDocument.body.style.color = "#212529";
  document.getElementById("inneriframe_introduce").contentDocument.body.style.fontWeight = "400";
}

const Introduce = ({ handleCloseClick, isopen }) => {
  const output = {};
  if (handleCloseClick) {
    output.closeicon = (
      <Icon color="action" onClick={handleCloseClick} className="close-icon">close</Icon>
    );
  }

  const iframeResizerOptions = { 
    checkOrigin: false,
    bodyMargin: 30,
    resizedCallback: resizedCallback_introduce
  };

  return (
    <Drawer
      open={isopen}
      className="intro-drawer"
    >
      <div>
        <div className="intro-content">
            <h1>How Qatar funnels money to the world's terror organizations:</h1>
            <p />
            <p />
            <p>
              The emirate of Qatar has been known for many years as a strong supporter of Islamist movements. Not only did Qatar provide infrastructure and facilities for organizations tied to the GLOBAL MUSLIM BROTHERHOOD and/or HAMAS, Qatar also  financially supported other conservative Sunni Islamist movements.
            </p>
            <p>
              This report shows how Qatar has opened a branch of one of its most important funding infrastructures – Qatar Charity (QC) - at the heart of Europe’s financial center London.
            </p>
            <p>
              Due to its complexity the report is split into three chapters with subchapters: the original Qatar Charity, its branch in the UK and a single project – the Emaan Trust in Sheffield.
            </p>
            <p>
              You can access each chapter from the top-menu and read about it in the left sidebar. On the rightside you can see all relevant entities and their connections. Clicking on any connection or node will bring up further details and sources in the sidebar.
            </p>
            <p>
              <small>&copy; 2017 to 2018, 1389 Blog, Medford, OR 97501, United States of America.</small>
            </p>
            <div className='next-button' onClick={handleCloseClick}><b>Next</b></div>
            <div style={{ height: 80 }} />
        </div>
        <Icon color="action" onClick={handleCloseClick} className="close-icon">close</Icon>
      </div>
    </Drawer>
  );
};

Introduce.propTypes = {
  handleCloseClick: PropTypes.func,
  isopen: PropTypes.bool,
};

export default Introduce;



// WEBPACK FOOTER //
// ./scripts/components/Introduce.jsx